module.exports = __webpack_public_path__ + "static/media/fee_btech_2016.c9a84054.pdf";